import axios from 'axios';
import CONFIG from './smp_config';
import qs from 'qs';
// import store from '@/store/index.js';

const commonParams = {
  contextKey: CONFIG.contextConfig.key,
  countryCode: CONFIG.applicationConfig.countryCode || CONFIG.countryConfig.countryCode,
  languageCode: CONFIG.applicationConfig.languageCode || CONFIG.countryConfig.defaultLanguageCode
};

const service = axios.create({
  baseURL: CONFIG.hostConfig.apiProtocols + '://' + CONFIG.hostConfig.apiHost,
  timeout: 60000, // request timeout changed to 60sec as offersearch may take time
  params: commonParams,
  paramsSerializer: function(params) {
    return qs.stringify(params, { arrayFormat: 'repeat' })
  }
});

service.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    console.log(error);
    return Promise.reject(error);
  }
);

export default service;
